
export enum surveyStatus {
	Unassigned = 1,
	Assigned = 2,
	InProgress = 3,
	Completed = 4,
	UnPublished = 5,
	SubmittedWithWarning = 6
};


export enum SurveyCategory {
	TimeSurvey = 0,
	ExpenseSurvey = 1,
	ProjectSurvey = 2,
	AllSurvey = 3
};

export enum AssignmentEmailStatus {
	Sent = 1,
	NotSent = 0
};


export enum TemplateRequestType {
	Default = 0,
	Reminder = 1
};
export enum SurveyScreenType {
	Grid = 0,
	Details = 1
};